const translations = {
    access: 'Access',
    active: 'Active',
    addedToOrganization: 'Added to org',
    cancel: 'Cancel',
    inactive: 'Inactive',
    noSeatsRemaining: 'Your organization has no seats remaining.',
    role: 'Role',
    save: 'Save',
    saveError: 'This user could not be updated.',
    saving: 'Saving…',
    selectRole: 'Select a role',
    selectStatus: 'Select a status',
    status: 'Status'
};

export default translations;
